import { useEffect } from "react";

export function StnAds() {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src =
      "//embed.sendtonews.com/player3/embedcode.js?fk=DdsMvGEy&cid=11417&offsetx=0&offsety=0&floatwidth=500&floatheight=600&floatposition=bottom-right";
    script.setAttribute("data-type", "s2nScript");
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div>
      <div className="ad-label">ADVERTISEMENT</div>
      <div className="s2nPlayer k-DdsMvGEy" data-type="float"/>
    </div>
  );
}
